module.exports = __webpack_public_path__ + "static/media/pdf-download.3e1c32f1.svg";